import * as api from '../../api/appraisalDemo/zillow';
import { makeApiActionCreatorV3 } from '../utils';

export const ZILLOW_ZESTIMATE_FETCH_START =
  'ZILLOW/ZILLOW_ZESTIMATE_FETCH_START';
export const ZILLOW_ZESTIMATE_FETCH_SUCCESS =
  'ZILLOW/ZILLOW_ZESTIMATE_FETCH_SUCCESS';
export const ZILLOW_ZESTIMATE_FETCH_ERROR =
  'ZILLOW/ZILLOW_ZESTIMATE_FETCH_ERROR';

export const ZILLOW_ZPROPERTY_FETCH_START =
  'ZILLOW/ZILLOW_ZPROPERTY_FETCH_START';
export const ZILLOW_ZPROPERTY_FETCH_SUCCESS =
  'ZILLOW/ZILLOW_ZPROPERTY_FETCH_SUCCESS';
export const ZILLOW_ZPROPERTY_FETCH_ERROR =
  'ZILLOW/ZILLOW_ZPROPERTY_FETCH_ERROR';

export const ZILLOW_ZCOMPS_FETCH_START = 'ZILLOW/ZILLOW_ZCOMPS_FETCH_START';
export const ZILLOW_ZCOMPS_FETCH_SUCCESS = 'ZILLOW/ZILLOW_ZCOMPS_FETCH_SUCCESS';
export const ZILLOW_ZCOMPS_FETCH_ERROR = 'ZILLOW/ZILLOW_ZCOMPS_FETCH_ERROR';

export const fetchZestimate = makeApiActionCreatorV3(
  api.fetchZestimate,
  ZILLOW_ZESTIMATE_FETCH_START,
  ZILLOW_ZESTIMATE_FETCH_SUCCESS,
  ZILLOW_ZESTIMATE_FETCH_ERROR,
);
export const fetchZProperty = makeApiActionCreatorV3(
  api.fetchZProperty,
  ZILLOW_ZPROPERTY_FETCH_START,
  ZILLOW_ZPROPERTY_FETCH_SUCCESS,
  ZILLOW_ZPROPERTY_FETCH_ERROR,
);
export const fetchZComps = makeApiActionCreatorV3(
  api.fetchZComps,
  ZILLOW_ZCOMPS_FETCH_START,
  ZILLOW_ZCOMPS_FETCH_SUCCESS,
  ZILLOW_ZCOMPS_FETCH_ERROR,
);
